import { Loading, NoData } from "components/commons";
import { ACCESS_TOKEN, getItem } from "local-storage";
import moment from "moment";
import slugs from "navigation/slugs";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getSubscribed, getUserTradeById } from "services/apis/apis";

export const Subcribed: React.FC<any> = (props: any) => {
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const f = async () => {
      try {
        const accessToken = getItem(ACCESS_TOKEN) || "";
        if (!accessToken) return;
        setIsLoading(true);
        const result = await getSubscribed(accessToken);
        setData(result);
      } catch (error) {
        console.log("🚀 ~ file: HoldCard.tsx:21 ~ f ~ error:", error);
      } finally {
        setIsLoading(false);
      }
    };
    f();
  }, [props?.state?.id]);

  return (
    <div className="flex flex-col gap-4">
      {isLoading && <Loading />}

      {!isLoading && data?.length === 0 && <NoData />}

      {data?.map((el: any) => (
        <div
          className="border-2 rounded-xl border-gray-800 w-full"
          key={el?.id}
        >
          <div className={`flex p-4 gap-4 justify-between items-center `}>
            <div className="flex items-center gap-2 w-full">
              {el.type !== "buy_share" && el.type !== "sell_share" && (
                <div className="flex">
                  <div className="h-12 w-12 shadow-sm rounded-full overflow-hidden flex justify-center items-center">
                    <img
                      className="h-12 w-12 shadow-sm rounded-full object-fill"
                      // src={item?.metadata?.avatar_168x168}
                      src={el?.agent_avatar}
                      alt=""
                    />
                  </div>
                  <div className="h-12 w-12 shadow-sm rounded-full overflow-hidden flex justify-center items-center -translate-x-3">
                    <img
                      className="h-12 w-12 shadow-sm rounded-full object-fill"
                      // src={item?.metadata?.avatar_168x168}
                      src="/images/fantech-logo.png"
                      alt=""
                    />
                  </div>
                </div>
              )}
              {(el.type === "buy_share" || el.type === "sell_share") && (
                <div className="flex">
                  <div className="h-12 w-12 shadow-sm rounded-full overflow-hidden flex justify-center items-center">
                    <img
                      className="h-12 w-12 shadow-sm rounded-full object-fill"
                      // src={item?.metadata?.avatar_168x168}
                      src={el?.agent_avatar}
                      alt=""
                    />
                  </div>
                  <div className="h-12 w-12 shadow-sm rounded-full overflow-hidden flex justify-center items-center -translate-x-3">
                    <img
                      className="h-12 w-12 shadow-sm rounded-full object-fill"
                      // src={item?.metadata?.avatar_168x168}
                      src={el?.recipient_avatar}
                      alt=""
                    />
                  </div>
                </div>
              )}

              {/* {item?.metadata?.avatar_168x168 ? (
            <img
              className="h-12 w-12 shadow-sm rounded-full object-fill"
              src={item?.metadata?.avatar_168x168}
            />
          ) : (
            <i className="fa-duotone fa-user text-2xl text-primary"></i>
          )} */}

              <div className="flex-1 flex justify-between">
                <h6 className="flex flex-col items-baseline transition-all">
                  <span className={`text-sm font-normal leading-none mr-1`}>
                    <span className="text-secondary">{el?.agent_nickname}</span>
                    {el.type === "buy_share"
                      ? ` just bought ${Math.abs(el?.data?.amount)} `
                      : el.type === "sell_share"
                      ? ` just sold ${Math.abs(el?.data?.amount)} `
                      : el.type === "enable_trading"
                      ? "’s Share has enabled for trading "
                      : " just joined fan.tech "}

                    {el.type === "buy_share" || el.type === "sell_share" ? (
                      <>
                        <span className="text-secondary">
                          {el?.recipient_nickname}
                        </span>{" "}
                        Share
                      </>
                    ) : (
                      ""
                    )}
                  </span>
                  {el.type === "buy_share" || el.type === "sell_share" ? (
                    <span className="text-xs font-normal text-slate-500 mt-1">
                      {el?.data?.amount} ETH{" "}
                      {/* <span className="font-normal text-xl" role="separator">
                        ·
                      </span>{" "} */}
                      {/* {moment(el?.created_at).fromNow()} */}
                    </span>
                  ) : (
                    ""
                  )}
                </h6>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
